import { EditIntegrationDrawerContentProps } from '@modules/integrationsV2/types';
import { getIsEditableIntegration } from '@modules/integrationsV2/utils';
import { Box, Drawer } from '@mui/material';
import { IntegrationChannelType } from 'generated/graphql';
import {
  EditDiscordIntegrationDrawerContent,
  EditFacebookPagesIntegrationDrawerContent,
  EditIntegrationDescriptionDrawerContent,
  EditPlaystoreIntegrationDrawerContent,
  EditQualtricsIntegrationDrawerContent,
  EditRedditIntegrationDrawerContent,
  EditSalesforceIntegrationDrawerContent,
  EditSlackIntegrationDrawerContent,
  EditSurveyMonkeyIntegrationDrawerContent,
  EditTypeformIntegrationDrawerContent,
} from '../EditIntegrationDrawerContent';

const channelTypeToEditIntegrationDrawerContentMap: Record<
  string,
  (props: EditIntegrationDrawerContentProps) => JSX.Element
> = {
  [IntegrationChannelType.Discord]: EditDiscordIntegrationDrawerContent,
  [IntegrationChannelType.Salesforce]: EditSalesforceIntegrationDrawerContent,
  [IntegrationChannelType.Slack]: EditSlackIntegrationDrawerContent,
  [IntegrationChannelType.SurveyMonkey]:
    EditSurveyMonkeyIntegrationDrawerContent,
  [IntegrationChannelType.Typeform]: EditTypeformIntegrationDrawerContent,
  [IntegrationChannelType.Playstore]: EditPlaystoreIntegrationDrawerContent,
  [IntegrationChannelType.FacebookPages]:
    EditFacebookPagesIntegrationDrawerContent,
  [IntegrationChannelType.Reddit]: EditRedditIntegrationDrawerContent,
  [IntegrationChannelType.Qualtrics]: EditQualtricsIntegrationDrawerContent,
};

export const EditIntegrationDrawer = ({
  isOpen,
  integrationChannel,
  onDrawerClose,
  integrationID,
  integrationData,
  integrationType,
  namespace,
  description,
}: EditIntegrationDrawerContentProps & {
  isOpen: boolean;
}) => {
  const isEditableintegration = getIsEditableIntegration({
    channelType: integrationChannel.type,
    integrationData,
    integrationType,
  });

  if (!isEditableintegration) {
    return null;
  }

  const EditIntegrationDrawerContent =
    channelTypeToEditIntegrationDrawerContentMap[integrationChannel.type];

  return (
    <Drawer
      open={isOpen}
      anchor="right"
      onClose={onDrawerClose}
      keepMounted={false}
    >
      <Box width="45vw" minWidth="700px" height="100vh" overflow="auto">
        {EditIntegrationDrawerContent ? (
          <EditIntegrationDrawerContent
            integrationData={integrationData}
            onDrawerClose={onDrawerClose}
            integrationID={integrationID}
            integrationType={integrationType}
            integrationChannel={integrationChannel}
            description={description}
            namespace={namespace}
          />
        ) : (
          <EditIntegrationDescriptionDrawerContent
            onDrawerClose={onDrawerClose}
            integrationID={integrationID}
            integrationType={integrationType}
            integrationData={integrationData}
            integrationChannel={integrationChannel}
            description={description}
            namespace={namespace}
          />
        )}
      </Box>
    </Drawer>
  );
};
